// extracted by mini-css-extract-plugin
export default {"content":"Header_content__Y9tv4"};